import type { AIAutofillGetType, AIAutofillDataType } from 'App/resources/Model/AIAutofill';
import ResourceTyped from './ResourceTyped';

export type GenerateCustomFieldValueParams = {
	entityType: 'account';
	customFieldIds: number[];
	clientId: number;
};

class AIAutofillResource extends ResourceTyped<AIAutofillGetType> {
	constructor() {
		super('AIAutofill');
	}

	generateCustomFieldValue(params: GenerateCustomFieldValueParams): Promise<{ data: AIAutofillDataType[] }> {
		return super._postRequest('', params).then(d => d.data);
	}
}

const resource = new AIAutofillResource();
export default resource;
